// Utility functions for date-based proverb selection

/**
 * Gets a deterministic index based on the current date
 * This ensures the same proverb is shown for the entire day
 */
export const getDailyProverbIndex = (totalProverbs: number): number => {
  const today = new Date();
  // Use year, month, and day to create a seed
  const year = today.getFullYear();
  const month = today.getMonth() + 1; // 0-indexed
  const day = today.getDate();

  // Simple hash function to get a consistent index
  const seed = year * 10000 + month * 100 + day;

  // Use modulo to get an index within the proverbs array
  return seed % totalProverbs;
};

/**
 * Format date for display
 */
export const formatDate = (date: Date = new Date()): string => {
  return date.toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};
